import {charcoal} from '../sass/base/_exports.sass';

export const FavoritesFillIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0014 6.03864C19.1334 3.22664 23.9734 3.31997 26.9907 6.34264C30.0067 9.36664 30.1107 14.1826 27.3054 17.324L15.9987 28.6466L4.6947 17.324C1.88936 14.1826 1.9947 9.35864 5.00936 6.34264C8.02936 3.32397 12.86 3.22264 16.0014 6.03864Z"
        fill={color}
        stroke={color}
      />
    </svg>
  );
};
